import { NotificationType } from '@kcftech/prometheus-client';
import { useMemo } from 'react';
import { FilterPane } from 'shared/filter_pane/FilterPane';
import { QuickFilterToggle } from 'shared/filter_pane/QuickFilterToggle';
import { toggleArrayItem } from 'utils/array';

type NotificationSubscriptionFilterPaneProps = Readonly<{
    filters: NotificationType[];
    onChange: React.Dispatch<React.SetStateAction<NotificationType[]>>;
}>;

export function NotificationSubscriptionsFilterPane({
    filters,
    onChange,
}: NotificationSubscriptionFilterPaneProps) {
    const filterCount = useMemo(() => filters.length, [filters.length]);

    const isHardwareAlertsToggled = filters.includes(NotificationType.Hardware);
    const isIndicatorAlertsToggled = filters.includes(NotificationType.Indicator);
    const isHardwareIssuesToggled = filters.includes(NotificationType.HardwareHealth);
    const isMachineHealthToggled = filters.includes(NotificationType.MachineHealth);

    const isAllToggled = filterCount === 0;

    const toggleHardwareAlerts = () =>
        onChange(toggleArrayItem(filters, NotificationType.Hardware));

    const toggleIndicatorAlerts = () =>
        onChange(toggleArrayItem(filters, NotificationType.Indicator));

    const toggleHardwareIssues = () =>
        onChange(toggleArrayItem(filters, NotificationType.HardwareHealth));

    const toggleMachineHealth = () =>
        onChange(toggleArrayItem(filters, NotificationType.MachineHealth));

    const resetFilters = () => onChange([]);

    return (
        <FilterPane id="filter-pane" filterCount={filterCount}>
            <QuickFilterToggle
                id="filter-pane-all"
                isToggled={isAllToggled}
                onToggle={resetFilters}
            >
                All
            </QuickFilterToggle>
            <QuickFilterToggle
                id="machine-health"
                isToggled={isMachineHealthToggled}
                onToggle={toggleMachineHealth}
            >
                Machine Health Issues
            </QuickFilterToggle>
            <QuickFilterToggle
                id="indicator-alerts"
                isToggled={isIndicatorAlertsToggled}
                onToggle={toggleIndicatorAlerts}
            >
                Indicator Alerts
            </QuickFilterToggle>
            <QuickFilterToggle
                id="hardware-issues"
                isToggled={isHardwareIssuesToggled}
                onToggle={toggleHardwareIssues}
            >
                Hardware Issues
            </QuickFilterToggle>
            <QuickFilterToggle
                id="hardware-alerts"
                isToggled={isHardwareAlertsToggled}
                onToggle={toggleHardwareAlerts}
            >
                Hardware Alerts
            </QuickFilterToggle>
        </FilterPane>
    );
}
